export default {
  FORBIDDEN: 403,
  NO_AUTHORIZED: 401,
  NO_RESULTS: 204,
  SUCCESS: [200, 201, 202, 203, 204]
};